//#region src/framework/utils/get-initials/get-initials.ts
/**
*
* @param name
* @example
* // returns JD
* getInitials('John Doe')
* @example
* // returns JD
* getInitials('John Franklin Doe')
* @example
* // returns J
* getInitials('John')
* @returns Initials related to name or undefined.
*/
const getInitials = (name) => {
	if (name.length === 0) return;
	if (/^[a-z]\.?[a-z]\.?$/i.test(name)) return name.replaceAll(".", "").toUpperCase();
	const parts = name.split(" ");
	if (parts.length > 1) {
		const first = parts.shift();
		const last = parts.pop();
		return `${first?.[0]}${last?.[0]}`.toUpperCase();
	}
	return parts[0][0].toUpperCase();
};

//#endregion
export { getInitials };